
export default {
  name: 'rzFileField',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    buttonText: { type: String, default: 'Загрузить' },
    error: { type: String, default: '' },
    details: { type: String, default: '' },
    staticLabel: { type: Boolean, default: false },
    openOnLabel: { type: Boolean, default: false },
    isError: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
  },
  computed: {
    classes() {
      return {
        'file-field--static-label': this.isStaticLabel,
        'file-field--dynamic-label': !this.isStaticLabel,
        'file-field--filled': this.filesNames.length,
        'file-field--label-open': this.openOnLabel,
        'file-field--error': this.isError,
      };
    },
    filesNames() {
      if (!this.value.length) return '';
      return this.value.reduce((sum, current) => {
        return `${sum  }${current.name}, `;
      }, '');
    },
    isStaticLabel() {
      return !!this.placeholder.length || this.staticLabel; 
    },
    showLabel() {
      return this.isStaticLabel ? true : !this.filesNames.length;
    }
  },
  methods: {
    addFile(files) {
      this.$emit('change', [...this.value, ...files]);
    },
    clickOnInput() {
      this.$refs.input.click();
    },
  },
};
